import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function ThemedIndicaFlowerTypeIndicator(props) {
  const config = useThemeConfig();
  const ThemedIndicaFlowerTypeIndicator = config.components.IndicaTypeIndicator;

  return <ThemedIndicaFlowerTypeIndicator {...props} />;
}
